import type { Key } from 'react';

type MessageType = 'success' | 'error' | 'warning' | 'info' | 'loading';

type GlobalAntdApp = {
  message?: Record<MessageType, (...args: any[]) => any>;
  notification?: {
    open?: (config: Record<string, any>) => any;
    destroy?: (key?: Key) => void;
  };
  modal?: {
    confirm?: (config: Record<string, any>) => any;
  };
};

let globalAntdApp: GlobalAntdApp | null = null;

export const setGlobalAntdApp = (app: GlobalAntdApp) => {
  globalAntdApp = app;
};

export const getGlobalAntdApp = () => globalAntdApp;

export const showAppMessage = (type: MessageType, ...args: any[]) => {
  const fn = globalAntdApp?.message?.[type];
  if (typeof fn === 'function') {
    return fn(...args);
  }

  const fallback = args[0];
  const content =
    typeof fallback === 'string'
      ? fallback
      : fallback?.content || fallback?.message || `[${type.toUpperCase()}]`;
  console[type === 'error' ? 'error' : 'log'](content);
  return undefined;
};

export const openAppNotification = (config: Record<string, any>) => {
  if (typeof globalAntdApp?.notification?.open === 'function') {
    return globalAntdApp.notification.open(config);
  }

  console.log(config?.message || 'notification.open');
  return undefined;
};

export const destroyAppNotification = (key?: Key) => {
  if (typeof globalAntdApp?.notification?.destroy === 'function') {
    globalAntdApp.notification.destroy(key);
  }
};

export const confirmAppModal = (config: Record<string, any>) => {
  if (typeof globalAntdApp?.modal?.confirm === 'function') {
    return globalAntdApp.modal.confirm(config);
  }

  if (typeof config?.onOk === 'function') {
    return config.onOk();
  }

  return undefined;
};
